import { useState, useEffect, useRef } from "react";

const SearchableMultiDropdown = ({
    options = [],
    value = [],
    onChange,
    labelField = "name",
    valueField = "id",
    placeholder = "Select",
    required = false
}) => {
    const [search, setSearch] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const [highlightIndex, setHighlightIndex] = useState(-1);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowDropdown(false);
                setHighlightIndex(-1);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const filteredOptions = options.filter(item =>
        item[labelField]?.toLowerCase().includes(search.toLowerCase())
    );

    const allFilteredIds = filteredOptions.map(i => i[valueField]);
    const isAllSelected =
        allFilteredIds.length > 0 &&
        allFilteredIds.every(id => value.includes(id));

    // 🔥 SELECT ALL / UNSELECT ALL
    const handleSelectAll = () => {
        if (isAllSelected) {
            // remove filtered items
            onChange(value.filter(v => !allFilteredIds.includes(v)));
        } else {
            // add missing filtered items
            const newValues = Array.from(
                new Set([...value, ...allFilteredIds])
            );
            onChange(newValues);
        }
    };

    const handleSelect = (item) => {
        const id = item[valueField];

        const newValue = value.includes(id)
            ? value.filter(v => v !== id)
            : [...value, id];

        onChange(newValue);
    };

    return (
        <div ref={wrapperRef} style={{ position: "relative", width: "100%" }}>

            {/* SEARCH INPUT */}
            <input
                className="modify_im_input mode_category1"
                type="text"
                value={search}
                placeholder={
                    value.length > 0
                        ? `${value.length} selected`
                        : placeholder
                }
                onChange={(e) => {
                    setSearch(e.target.value);
                    setShowDropdown(true);
                }}
                onFocus={() => setShowDropdown(true)}
            />

            {/* CHIPS */}
            {value.length > 0 && (
                <div style={{ marginTop: 5, display: "flex", flexWrap: "wrap", gap: 5 }}>
                    {options
                        .filter(opt => value.includes(opt[valueField]))
                        .map(opt => (
                            <div
                                key={opt[valueField]}
                                style={{
                                    background: "rgb(227 227 240 / 47%)",
                                    padding: "3px 8px",
                                    borderRadius: 12,
                                    fontSize: 12,
                                    display: "flex",
                                    gap: 5,
                                    alignItems: "center"
                                }}
                            >
                                {opt[labelField]}
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                        onChange(value.filter(v => v !== opt[valueField]))
                                    }
                                >
                                    ✕
                                </span>
                            </div>
                        ))}
                </div>
            )}

            {/* DROPDOWN */}
            {showDropdown && (
                <div className="dropdown_box">

                    {/* 🔥 SELECT ALL ROW */}
                    {filteredOptions.length > 0 && (
                        <div
                            className="dropdown_item"
                            style={{
                                fontWeight: 600,
                                borderBottom: "1px solid #eee"
                            }}
                            onClick={handleSelectAll}
                        >
                            <input type="checkbox" readOnly checked={isAllSelected} />
                            Select All
                        </div>
                    )}

                    {/* OPTIONS */}
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map(item => {
                            const id = item[valueField];
                            const isSelected = value.includes(id);

                            return (
                                <div
                                    key={id}
                                    className="dropdown_item"
                                    onClick={() => handleSelect(item)}
                                >
                                    <input type="checkbox" checked={isSelected} readOnly />
                                    {item[labelField]}
                                </div>
                            );
                        })
                    ) : (
                        <div className="dropdown_item">No data found</div>
                    )}
                </div>
            )}
        </div>
    );
};

export default SearchableMultiDropdown;